import PropTypes from 'prop-types';

var Sizes;
(function (Sizes) {
    Sizes["sm"] = "sm";
    Sizes["md"] = "md";
    Sizes["lg"] = "lg";
    Sizes["xl"] = "xl";
})(Sizes || (Sizes = {}));
var propTypes = {
    hasBackground: PropTypes.bool,
    className: PropTypes.string,
    greyAnimation: PropTypes.bool,
    size: PropTypes.string,
};
var defaultProps = {
    hasBackground: false,
    greyAnimation: false,
    size: Sizes.md,
};

export { Sizes, defaultProps, propTypes };
